<template>
  <div class="cards mx-auto shadow">
    <div class="h1 bg-light py-2 primary-font card-title-border">
      {{msg}}
    </div>

    <div class="p-5 m-4 bg-warning rounded">
      <div class="container-fluid py-5">
        <h1 class="display-5 fw-bold">Tech Blog / Random Facts / Code Samples </h1>
        <p class="text-center">This is just a humble static site created to share a few insights from my career and code that I'm tinkering with.</p>
            <img
              alt="Vue logo"
              class="logo animated bounce"
              src="https://www.kindpng.com/picc/m/35-351705_linux-logo-png-linux-logo-circle-transparent-png.png"
              width="100"
              height="120"
            />
      </div>
    </div>

    <div class="row align-items-md-stretch mx-2 mb-4">
      <div class="col-md-6">
        <div class="h-100 p-5 text-white bg-dark rounded">
          <h2>Contact</h2>
          <p>I'm a software engineer that's always looking for more business. If you would like to connect to work on open source projects (games, apps, services, whatever), please contact me on my LinkedIn account! 🧐</p>
          <button class="btn btn-outline-light" type="button" @click="navToLinks()">LinkedIn</button>
        </div>
      </div>
      <div class="col-md-6 panel-margin">
        <div class="h-100 p-5 bg-danger border rounded text-white">
          <h2>🚧 Evolving 🚧</h2>
          <p>This site is always under construction.</p>
          <button class="btn btn-outline-light" type="button" @click="underConstruction()">Definition</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  methods: {
    underConstruction() {
      window.location.href='https://en.wikipedia.org/wiki/Construction';
    },
    navToLinks() {
      // window.location.href='https://tech.maxico.xyz/links';
      this.$router.push({ name: "Links" });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.logo {
  border-radius: 50px;
  filter: invert(100%);
}
.hello {
  background-color: #fff;
  padding-top: 1rem;
  padding-bottom: 1rem;
  border: #000 solid 1px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

@media (min-width: 768px) {
  .bd-placeholder-img-lg {
    font-size: 3.5rem;
  }
}
@media (max-width: 768px) {
  .panel-margin {
    margin-top: 1.5rem;
  }
}
</style>